module.exports = __webpack_public_path__ + "media/images/common/small_on-8ca31df95e9d5dacc0f89ac3def83242.gif";